import moment from 'moment'

export const isExpiringSoon = (expirationDate) => {
  const now = moment()
  const expiration = moment(expirationDate)

  return !!expirationDate &&
  expiration.diff(now, 'days') <= 15 &&
  expiration.isAfter(now)
}

export const calculatePriceWithoutDiscount = (packageInfo, additionalServices) => {
  const mainServicePrice = (packageInfo.price * 100) / (100 - packageInfo.packageDiscount)
  const additionalServicesPrice = additionalServices?.reduce((acc, curr) => acc + (curr.price * curr.packageQuantity), 0)
  if (typeof mainServicePrice !== 'number' || typeof additionalServicesPrice !== 'number') return
  return mainServicePrice + additionalServicesPrice
}

export const getNextServicePositionInPackage = (purchasedPackage) => {
  const currentUsage = purchasedPackage?.currentUsages?.service
  return currentUsage ? currentUsage + 1 : 1
}

export const buildSelectedPurchasedPackage = (purchasedPackageData) => {
  if (!purchasedPackageData) return undefined

  const {
    pet,
    service,
    professional,
    partner,
    additionalServices,
    currentUsages,
    expiresAt
  } = purchasedPackageData

  const availableAdditionals = (additionalServices || [])
    .filter(item => (currentUsages?.additional?.[item.id] || 0) < item.packageQuantity)
    .map(({ id, ...rest }) => ({ ...rest, value: id }))

  return {
    pet,
    professional,
    partner,
    additionalServices,
    currentUsages,
    availableAdditionals,
    service,
    expiresAt
  }
}

export const resolvePackageServiceIndex = (schedulings, schedulingId) => {
  if (!schedulingId || !schedulings?.length) return undefined

  const index = schedulings.findIndex(scheduling => scheduling.id === schedulingId)
  return index >= 0 ? index + 1 : undefined
}

export const PURCHASED_PACKAGE_PAYMENT_METHOD_LABEL = {
  CREDIT_CARD: 'Cartão de crédito',
  DEBIT_CARD: 'Cartão de débito',
  CASH: 'Dinheiro',
  PIX: 'Pix'
}

export const filterAdditionalServiceIdsByPackageAvailability = (selectedIds, purchasedPackage) => {
  if (!purchasedPackage || !selectedIds?.length) {
    return selectedIds || []
  }

  if (Array.isArray(purchasedPackage.additionalServices) && purchasedPackage.additionalServices.length === 0) {
    return []
  }

  if (!purchasedPackage.additionalServices?.length) {
    return selectedIds || []
  }

  const usage = purchasedPackage.currentUsages?.additional || {}
  const allowed = new Set(
    purchasedPackage.additionalServices
      .filter((item) => (usage[item.id] || 0) < item.packageQuantity)
      .map((item) => item.id)
  )

  return selectedIds.filter((id) => allowed.has(id))
}

export function parseSchedulingAdditionalQuantity (item) {
  if (item == null) return 0

  const raw = item.quantity
  if (raw === undefined || raw === null) return 0

  const asNumber = typeof raw === 'number' ? raw : Number(String(raw).trim())
  if (!Number.isFinite(asNumber) || asNumber < 0) return 0

  return Math.floor(asNumber)
}

export function sumAdditionalServiceQuantitiesById (entries) {
  const quantityByServiceId = new Map()

  for (const entry of entries) {
    if (!entry?.id) continue

    const parsed = Number(entry.quantity)
    const lineQty = Number.isFinite(parsed) && parsed >= 0 ? Math.floor(parsed) : 0
    const accumulated = quantityByServiceId.get(entry.id) ?? 0
    quantityByServiceId.set(entry.id, accumulated + lineQty)
  }

  return Array.from(
    quantityByServiceId,
    ([id, quantity]) => ({ id, quantity })
  )
}

export function hasUnavailablePackageAdditionalsForRepeat (schedulingAdditionalServices, purchasedPackage) {
  if (!schedulingAdditionalServices?.length || !purchasedPackage?.additionalServices?.length) {
    return false
  }

  const usage = purchasedPackage.currentUsages?.additional || {}
  const pkgById = new Map(
    purchasedPackage.additionalServices.map((item) => [item.id, item])
  )

  return schedulingAdditionalServices.some((svc) => {
    const id = svc?.id
    if (!id) return false
    const pkgItem = pkgById.get(id)
    if (!pkgItem) return false
    return (usage[id] || 0) >= pkgItem.packageQuantity
  })
}
